import { emptyApi } from "./emptyApi";

type ApiTokenStatus = {
  has_token: false;
};

type ApiTokenInfo = {
  has_token: true;
  token_prefix: string;
  created_at: string;
  last_used_at: string | null;
  expiry: string;
  is_expired: boolean;
};

export type ApiTokenResponse = ApiTokenStatus | ApiTokenInfo;

type GenerateApiTokenResponse = {
  token: string;
  token_prefix: string;
};

export const apiTokenApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getApiToken: build.query<ApiTokenResponse, void>({
      query: () => ({
        url: `/api/inkle/company/user/api-token/`,
      }),
      providesTags: ["API_TOKEN"],
    }),

    generateApiToken: build.mutation<GenerateApiTokenResponse, void>({
      query: () => ({
        url: `/api/inkle/company/user/api-token/`,
        method: "POST",
      }),
      invalidatesTags: ["API_TOKEN"],
    }),

    revokeApiToken: build.mutation<void, void>({
      query: () => ({
        url: `/api/inkle/company/user/api-token/`,
        method: "DELETE",
      }),
      invalidatesTags: ["API_TOKEN"],
    }),
  }),
});

export const {
  useGetApiTokenQuery,
  useGenerateApiTokenMutation,
  useRevokeApiTokenMutation,
} = apiTokenApi;
